<template>
    <div class="login-container" :style="portalStyles">
        <div class="login-right" :class="{ 'has-background': portalConfig.background_image }">
            <!-- LOGO显示 -->
            <div v-if="portalConfig.logo" class="portal-logo">
                <img :src="portalConfig.logo" alt="Logo" />
            </div>

            <!-- 标题显示 -->
            <h1 class="portal-title">{{ portalConfig.name }}</h1>
        </div>

        <div class="login-left" style="position: relative;">
            <!-- LOGO显示在左上角 -->


            <transition name="slide-fade" mode="out-in">
                <div class="form-container">
                    <h2>Sign Up</h2>
                    <p class="or-text">Use your email</p>

                    <el-input v-model="form.name" placeholder="Name" prefix-icon="el-icon-user"
                        :class="{ 'input-error': errors.name }" />
                    <span v-if="errors.name" class="error-message">{{ errors.name }}</span>

                    <el-input style="margin: 10px 0;" v-model="form.email" placeholder="Email"
                        prefix-icon="el-icon-message" :class="{ 'input-error': errors.email }" />
                    <span v-if="errors.email" class="error-message">{{ errors.email }}</span>

                    <el-input v-model="form.password" placeholder="Password" prefix-icon="el-icon-lock" show-password
                        :class="{ 'input-error': errors.password }" />
                    <span v-if="errors.password" class="error-message">{{ errors.password }}</span>

                    <div class="verification-container">
                        <el-input v-model="form.code" placeholder="Enter verification code"
                            style="flex: 1; margin-right: 10px;" :class="{ 'input-error': errors.code }" />
                        <button type="button" class="verification-button themed-button"
                            :disabled="isCodeSent || !isValidEmail" @click="sendVerificationCode">
                            {{ buttonText }}
                        </button>
                    </div>
                    <span v-if="errors.code" class="error-message">{{ errors.code }}</span>

                    <el-button type="primary" class="login-btn themed-button" @click="register">Sign Up</el-button>

                    <div class="signup-link">
                        Already have an account?
                        <span @click="changeSign_in" class="themed-link-span">Go to Login</span>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { register, sendCode } from "@/api/auth";
import { portalConfigMixin } from "@/mixins/portalConfig"; // 引入混入

export default {
    name: "UserRegister",
    mixins: [portalConfigMixin], // 使用混入
    data() {
        return {
            form: {
                name: '',
                email: '',
                password: '',
                code: ''
            },
            errors: {
                name: '',
                email: '',
                password: '',
                code: ''
            },
            isCodeSent: false,
            countdown: 60,
        };
    },

    mounted() {
        const workspaceId = localStorage.getItem("workspaceId");
        if (!workspaceId) {
            window.location.href = "https://lazifunnel.com";
        }
    },

    computed: {
        buttonText() {
            return this.isCodeSent ? `${this.countdown} seconds left` : "Get Code";
        },
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.form.email);
        }
    },

    methods: {
        changeSign_in() {
            this.$router.push({ path: '/sign_in' });
        },

        async sendVerificationCode() {
            if (!this.isValidEmail) {
                this.$message.error("Please enter a valid email address!");
                return;
            }
            const data = {
                scene: 'register',
                name: this.form.name,
                email: this.form.email
            }
            try {
                const res = await sendCode(data)
                if (res.success) {
                    this.startCountdown();
                    this.$message.success("Verification code sent!");
                }
            } catch (error) {
                console.error(error);
            }
        },

        startCountdown() {
            this.isCodeSent = true;
            this.countdown = 60;
            const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                    this.isCodeSent = false;
                }
            }, 1000);
        },

        validateForm() {
            this.errors = {
                name: this.form.name ? '' : 'Name is required.',
                email: this.form.email ? (this.isValidEmail ? '' : 'Invalid email format.') : 'Email is required.',
                password: this.form.password ? '' : 'Password is required.',
                code: this.form.code ? '' : 'Verification code is required.'
            };
            return Object.values(this.errors).every(error => error === '');
        },

        async register() {
            if (!this.validateForm()) {
                this.$message.error("Please complete the form correctly!");
                return;
            }
            try {
                const encryptedPassword = CryptoJS.SHA256(this.form.password).toString();
                const payload = { ...this.form, password: encryptedPassword };

                const res = await register(payload);
                if (res.success) {
                    this.$message.success("Registration successful!");
                    this.$router.push({ path: '/sign_in' });
                }
            } catch (error) {
                console.error(error);
            }
        }
    }
};
</script>

<style scoped>
@import "@/assets/css/auth.css";

/* 使用CSS变量应用主题色 */
.login-container {
    --theme-color: #007bff;
    --background-image: none;
}

/* 左侧LOGO样式 - 左上角显示 */


.portal-logo-left img {
    max-width: 120px;
    max-height: 60px;
    object-fit: contain;
}

/* 右侧背景区域 */
.login-right {
    background-color: var(--theme-color);
    background-image: var(--background-image);
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login-right.has-background {
    background-color: transparent;
}

/* LOGO样式 */
.portal-logo {
    margin-bottom: 20px;
 
}

.portal-logo img {
    max-width: 150px;
    max-height: 80px;
    object-fit: contain;
}

/* 标题样式 */
.portal-title {
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    text-align: center;
    margin: 0;
}

/* 主题按钮样式 */
.themed-button {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
}

.themed-button:hover {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
    opacity: 0.8;
}

/* 主题链接样式 */
.themed-link-span {
    color: var(--theme-color);
    cursor: pointer;
}

.themed-link-span:hover {
    opacity: 0.8;
}

/* 验证码按钮 */
.verification-button {
    background-color: var(--theme-color);
    border: 1px solid var(--theme-color);
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    white-space: nowrap;
}

.verification-button:hover:not(:disabled) {
    opacity: 0.8;
}

.verification-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Vue 过渡动画的类名 */
.slide-fade-enter-active {
    animation: slideIn 0.5s ease forwards;
}

.slide-fade-leave-active {
    animation: slideOut 0.5s ease forwards;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

/* 通用样式 */
.or-text {
    text-align: center;
    margin: 20px 0;
}

.login-btn {
    margin-top: 20px;
    width: 100%;
}

.signup-link {
    text-align: center;
    margin-top: 15px;
}

.verification-container {
    display: flex;
    margin-top: 10px;
}

.input-error {
    border-color: red !important;
}

.error-message {
    color: red;
    font-size: 12px;
    margin-bottom: 10px;
    display: block;
}

@media screen and (max-width: 768px) {
    .login-container {
        flex-direction: column;
    }

    .login-right {
        flex: 1;
        width: 100%;
        height: 100vh;
        font-size: 2rem;
        display: flex;
        align-items: center;
        align-items: flex-start;
    }

    .login-left {
        flex: 1;
        background: none;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 95%;
    }

    .form-container {
        background: white;
        padding: 20px;
        width: 90%;
        max-width: 400px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
}
</style>